import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet-async";
import drivingImage from "../PhotosGallery/rijbewijs-halen-oost-souburg.jpg";
import { Trans, useTranslation } from "react-i18next";

const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: clamp(1rem, 4vw, 2.5rem);
  min-height: calc(100vh - 7rem);
  color: darkgoldenrod;
  position: relative;
  text-align: center;
`;

const ImageContainer = styled.div`
  width: min(100%, 32rem);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;

  img {
    max-width: 100%;
    height: auto;
    border-radius: 15px;
    object-fit: cover;

    filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.7));

    animation: img-shine 3s infinite alternate;

    @keyframes img-shine {
      0% {
        box-shadow:
          2px 2px 10px rgba(0, 0, 0, 0.7),
          0 0 10px rgba(212, 175, 55, 0.7);
      }

      100% {
        box-shadow:
          2px 2px 10px rgba(0, 0, 0, 0.7),
          0 0 20px rgba(212, 175, 55, 0.9),
          0 0 30px rgba(212, 175, 55, 0.8);
      }
    }
  }
`;

const TextContainer = styled.div`
  width: min(100%, 60rem);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const WelcomeText = styled.h1`
  font-size: clamp(1.75rem, 5vw, 2.5rem);
  color: #d4af37;
  font-weight: 700;
`;

const DescriptionText = styled.p`
  font-size: clamp(1rem, 2.5vw, 1.2rem);
  line-height: 1.7;
  color: #d4af37;
  font-weight: 500;
`;

const RegistrationButton = styled.div`
  width: min(100%, 32rem);
  padding: 0.8rem 1.2rem;
  margin-top: 1.5rem;

  border-radius: 15px;

  background: linear-gradient(45deg, #b8860b, #d4af37);

  color: white;
  font-size: 1.2rem;
  font-weight: bold;

  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);

  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 5px 15px rgba(0,0,0,0.3);
  }
`;

const LinkText = styled.a`
  color: white;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Home: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>
          {t("home.seoTitle")}
        </title>

        <meta
          name="description"
          content={t("home.seoDescription")}
        />

        <meta
          name="keywords"
          content={t("home.seoKeywords")}
        />
      </Helmet>

      <HomeContainer>

        <ImageContainer>
          <img
            src={drivingImage}
            alt={t("home.imageAlt")}
          />
        </ImageContainer>


        <TextContainer>

          <WelcomeText>
            {t("home.title").split("|").map((line, index) => <React.Fragment key={line}>{index > 0 && <br />}{line}</React.Fragment>)}
          </WelcomeText>


          <DescriptionText>

            <Trans i18nKey="home.description" components={{ strong: <strong />, br: <br /> }} />

          </DescriptionText>

        </TextContainer>


        <RegistrationButton>

          {t("home.register")} {" "}

          <LinkText
            href="https://www.startmetjerijbewijs.nl/jangin-shekho/inschrijven"
            target="_blank"
            rel="noopener noreferrer"
          >
            <strong>
              {t("home.registerLink")}
            </strong>
          </LinkText>

        </RegistrationButton>


      </HomeContainer>
    </>
  );
};

export default Home;
